import { Store } from '../store/types';
import { CITY_PICKER_HINT, CITY_PICKER_MENU, HAMBURGER_MENU, REGIONS_MENU } from '../actions';

const initialState = {
  hamburgerMenuVisible: false,
  cityPickerVisible: false,
  regionsMenuVisible: false,
  hintShow: false,
};

export const headerDrawers = (store: Store) => {
  store.on('@init', (state) => ({
    ...state,
    headerDrawers: initialState,
  }));

  store.on(HAMBURGER_MENU.openDrawer, (state) => ({
    ...state,
    headerDrawers: {
      ...initialState,
      hamburgerMenuVisible: true,
    },
  }));

  store.on(HAMBURGER_MENU.closeDrawer, (state) => ({
    ...state,
    headerDrawers: { ...initialState },
  }));

  store.on(CITY_PICKER_MENU.openDrawer, (state) => ({
    ...state,
    headerDrawers: {
      ...initialState,
      cityPickerVisible: true,
    },
  }));

  store.on(REGIONS_MENU.openDrawer, (state) => ({
    ...state,
    headerDrawers: {
      ...state.headerDrawers,
      regionsMenuVisible: true,
    },
  }));

  store.on(REGIONS_MENU.closeDrawer, (state) => ({
    ...state,
    headerDrawers: {
      ...state.headerDrawers,
      regionsMenuVisible: false,
    },
  }));

  store.on(CITY_PICKER_MENU.closeDrawer, (state) => ({
    ...state,
    headerDrawers: { ...initialState },
  }));

  store.on(CITY_PICKER_HINT.openHint, (state) => ({
    ...state,
    headerDrawers: {
      ...state.headerDrawers,
      hintShow: true,
    },
  }));
  store.on(CITY_PICKER_HINT.closeHint, (state) => ({
    ...state,
    headerDrawers: {
      ...state.headerDrawers,
      hintShow: false,
    },
  }));
};

export type HeaderDrawersStore = {
  headerDrawers: {
    hamburgerMenuVisible: boolean;
    cityPickerVisible: boolean;
    regionsMenuVisible: boolean;
    hintShow: boolean;
  };
};
